// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2ouAE","content":"ManualTimeModal_content__2A_r9"};